module.exports = __webpack_public_path__ + "img/background_active_img_two.ce8e07c3.png";